<template>
	<div class="my-video" style="overflow: hidden;">
		<div class="video">
			<!-- 视频播放区 -->
			<!--		<video id="video1" :src="src" :poster="poster"></video>-->
			<div id='video1' :class="isPlay ? '' : 'video-container'">
				<video-player class="video-player vjs-custom-skin vjs-has-started"
							  ref="videoPlayer"
							  :playsinline="true"
							  @play="onPlayerPlay($event)"
							  :options="playerOptions">
				</video-player>
			</div>
			<!-- 遮罩层 -->
			<!--		<div class="cover">-->
			<!--			&lt;!&ndash; 居中的播放暂停状态 &ndash;&gt;-->
			<!--			<div id="playStatus"></div>-->
			<!--			&lt;!&ndash; 控件部分 &ndash;&gt;-->
			<!--			<div class="controls">-->
			<!--				&lt;!&ndash; 控件部分中的播放暂停状态 &ndash;&gt;-->
			<!--				<div id="contPlayStatus"></div>-->
			<!--				<div id="currentTime">00:00:00</div>-->
			<!--				&lt;!&ndash; 进度条 &ndash;&gt;-->
			<!--				<input id="progressBar" type="range" name="" min="0" max="1000" value="0">-->
			<!--				<div id="duration">00:00:00</div>-->
			<!--				<div id="volume_box">-->
			<!--					<div id="volume"></div>-->
			<!--					<div id="volumeInput"><input id="volumeInputRange" type="range" name="" min="0" max="100" value="100"></div>-->
			<!--				</div>-->
			<!--				<div id="fullScreen"></div>-->
			<!--			</div>-->
			<!--		</div>-->


		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				isPlay:false,
				playerOptions: {
					//播放速度
					// playbackRates: [0.5, 1.0, 1.5, 2.0],
					//如果true,浏览器准备好时开始回放。
					autoplay: false,
					// 默认情况下将会消除任何音频。
					muted: false,
					// 导致视频一结束就重新开始。
					loop: false,
					// 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					preload: 'auto',
					language: 'zh-CN',
					// 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
					aspectRatio: '16:9',
					// 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
					fluid: true,
					sources: [{
						//类型
						type: "video/mp4",
						//url地址
						src: this.src
					}],
					//你的封面地址
					poster: this.poster,
					//允许覆盖Video.js无法播放媒体源时显示的默认信息。
					notSupportedMessage: '此视频暂无法播放，请稍后再试',
					controlBar: {
						timeDivider: true,
						durationDisplay: true,
						remainingTimeDisplay: false,
						//全屏按钮
						fullscreenToggle: true
					},
				}
			}
		},
		props:['src','poster'],
		watch:{
			src(n,o){
				this.playerOptions.sources[0].src = n
			},
			poster(n,o){
				this.playerOptions.poster = n
			}
		},
		methods:{
			onPlayerPlay(e){
				this.isPlay = true
				this.$refs.videoPlayer.player.play()
			},
		},
		mounted(){
			this.playerOptions.sources[0].src = this.src
			this.playerOptions.poster = this.poster
			// var divVideo = document.getElementsByClassName("video")[0];
			// var divCover = document.getElementsByClassName("cover")[0];
			// var video1 = document.getElementById("video1");
			// var playStatus = document.getElementById("playStatus");
			// var controls = document.getElementsByClassName("controls")[0];
			// var contPlayStatus = document.getElementById("contPlayStatus");
			// var currentTime = document.getElementById("currentTime");
			// var progressBar = document.getElementById("progressBar");
			// var duration = document.getElementById("duration");
			// var volume = document.getElementById("volume");
			// var volume_box = document.getElementById("volume_box");
			// var volumeInput = document.getElementById("volumeInput");
			// var fullScreen = document.getElementById("fullScreen");
			//
			// divVideo.addEventListener("mouseenter", function() {
			// 	console.log('divVideo mouseenter')
			// 	divCover.style.display = "block";
			// })

			// divVideo.addEventListener("mouseleave", function() {
			// 	console.log('divVideo mouseleave')
			// 	divCover.style.display = "none";
			// })

			// video1.addEventListener("play", function() {
			// 	console.log('video1 play')
			// 	playStatus.style.backgroundImage = "none"
			// 	contPlayStatus.style.backgroundImage = "url("+require('../img/myVideo/pause32.svg')+")"
			// })

			// video1.addEventListener("pause", function() {
			// 	playStatus.style.backgroundImage = "url("+require('../img/myVideo/play.svg')+")"
			// 	contPlayStatus.style.backgroundImage = "url("+require('../img/myVideo/play32.svg')+")"
			//
			// })
			//
			// playStatus.addEventListener("click", play_pause);
			// contPlayStatus.addEventListener("click", play_pause);
			//
			// setInterval(function() {
			// 	progressBar.value = video1.currentTime / video1.duration * 1000;
			// 	currentTime.innerHTML = getTime(video1.currentTime);
			// 	duration.innerHTML = getTime(video1.duration);
			// }, 10)
			//
			// progressBar.addEventListener("input", function(e) {
			// 	console.log('progressBar')
			// 	video1.currentTime = video1.duration * (progressBar.value / 1000);
			// 	video1.play();
			// })
			//
			// var currVolume;
			//
			// volume_box.addEventListener("mouseenter", function() {
			// 	volumeInput.style.display = "block";
			// })
			//
			// volume_box.addEventListener("mouseleave", function() {
			// 	volumeInput.style.display = "none";
			// })
			//
			// volume.addEventListener("click", function() {
			// 	if (video1.volume != 0) {
			// 		currVolume = video1.volume;
			// 		video1.volume = 0;
			// 		volumeInputRange.value = 0;
			// 		this.style.backgroundImage = "url("+require('../img/myVideo/volumeoff.svg')+")"
			// 	} else {
			// 		video1.volume = currVolume;
			// 		volumeInputRange.value = currVolume * 100;
			// 		this.style.backgroundImage = "url("+require('../img/myVideo/volume.svg')+")"
			// 	}
			// },false)
			//
			// video1.volume = 0.3;
			// volumeInputRange.value = 30;
			// volumeInputRange.addEventListener("input", function() {
			// 	video1.volume = Number(this.value) / 100;
			// 	volume.style.backgroundImage = video1.volume == 0 ? "url("+require('../img/myVideo/volumeoff.svg')+")" : "url("+require('../img/myVideo/volume.svg')+")"
			// })
			//
			// var fullScreenStatus = false;
			// fullScreen.addEventListener("click", function() {
			// 	if (!fullScreenStatus) {
			// 		var body = document.body;
			// 		body.webkitRequestFullScreen();
			// 		divVideo.style.width = innerWidth + "px";
			// 		divVideo.style.height = innerWidth / (1920 / 1080) + "px";
			// 		divVideo.style.position = "absolute";
			// 		divVideo.style.left = "50%";
			// 		divVideo.style.top = "50%";
			// 		divVideo.style.transform = "translate(-50%, -50%)";
			// 		divCover.style.width = innerWidth + "px";
			// 		divCover.style.height = innerWidth / (1920 / 1080) + "px";
			// 		controls.style.width = innerWidth + "px";
			// 		var num = innerWidth ;
			// 		progressBar.style.width = parseInt(getComputedStyle(progressBar).width) + num + "px";
			// 		// volumeInput.style.left = parseInt(getComputedStyle(volumeInput).left) + num + 15 + "px";
			// 		// volumeInput.style.display = 'block'
			// 		fullScreenStatus = true;
			// 	} else {
			// 		document.webkitCancelFullScreen();
			// 		divVideo.style.width = "";
			// 		divVideo.style.height = "";
			// 		divVideo.style.position = "";
			// 		divVideo.style.left = "";
			// 		divVideo.style.top = "";
			// 		divVideo.style.transform = "";
			// 		divCover.style.width = "";
			// 		divCover.style.height = "";
			// 		controls.style.width = "";
			// 		// var num = innerWidth - 1100;
			// 		progressBar.style.width = "";
			// 		// volumeInput.style.left = "";
			// 		// volumeInput.style.display = 'none'
			// 		fullScreenStatus = false;
			// 	}
			// })
			//
			// function play_pause() {
			// 	if (video1.paused) {
			// 		video1.play();
			// 		// audio1.pause();
			// 		check_box.checked = false;
			// 	} else {
			// 		video1.pause();
			// 	}
			// }
			//
			// function getTime(time) {
			// 	let hour = Math.floor(time / 3600) < 10 ? "0" + Math.floor(time / 3600) : Math.floor(time / 3600);
			// 	let min = Math.floor(time % 3600 / 60) < 10 ? "0" + Math.floor(time % 3600 / 60) : Math.floor(time % 3600 / 60);
			// 	var sec = Math.floor(time % 60) < 10 ? "0" + Math.floor(time % 60) : Math.floor(time % 60);
			// 	return hour + ":" + min + ":" + sec;
			// }
		}
	}
</script>

<style scoped>
	.demo{
		display: inline-block;
		width: 600px;
		height: 338px;
		text-align: center;
		line-height: 100px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo:hover{
		display: block;
	}
  .my-video .video {
		width: 1920px;
		height: 1080px;
		margin: 0 auto;
		position: relative;
	}
  .my-video .video video {
		/* width: 1080px;
        height: 460px; */
		object-fit:fill;
		/*position: absolute;*/
		/*left: 50%;*/
		/*transform: translateX(-50%);*/
		height: 100%;
		/* object-fit: contain; */
		/*object-position: center center;*/
	}

  .my-video video::-webkit-media-controls {
		/* 去掉全屏时显示的自带控制条 */
		display: none !important;
	}

  .my-video .cover {
		width: 1920px;
		height: 1080px;
		/* background-color: rgba(116, 116, 116, 0.3); */
		position: absolute;
		left: 0;
		top: 0;
	}

  .my-video #playStatus {
		width: 72px;
		height: 51px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background-image: url(../img/myVideo/play.svg);
		background-repeat: no-repeat;
	}

  .my-video .controls {
		width: 1920px;
		height: 64px;
		background-image: linear-gradient(transparent, #00000030);
		position: absolute;
		bottom: 0;
		display: flex;
		justify-content: space-around;
	}

  .my-video #contPlayStatus {
		width: 54px;
		height: 36px;
		background-image: url(../img/myVideo/play32.svg);
		background-repeat: no-repeat;
		position: relative;
		top: 16px;
		background-position-x:center;
		background-position-y:center;

		/* border: 1px solid red; */
	}

  .my-video #currentTime {
		width: 84px;
		height: 64px;
		/* border: 1px solid red; */
		text-align: center;
		line-height: 64px;
		font-size: 16px;
		color: #ffffff;
	}

  .my-video #progressBar {
		/* 进度条样式 */
		-webkit-appearance: none;
		width: 1400px;
		height: 5px;
		/* border: 1px solid red; */
		position: relative;
		top: 28px;
		background-color: #eee;
		border-radius: 2.5px;
	}

  .my-video #progressBar::-webkit-slider-thumb {
		/* 进度条滑块样式 */
		-webkit-appearance: none;
		width: 12px;
		height: 12px;
		cursor: pointer;
		background: none repeat scroll 0 0 #ffffff;
		border-radius: 6px;
	}

  .my-video #duration {
		width: 84px;
		height: 64px;
		/* border: 1px solid red; */
		text-align: center;
		line-height: 64px;
		font-size: 16px;
		color: #ffffff;
	}

  .my-video #volume {
		width: 32px;
		height: 32px;
		/* border: 1px solid red; */
		position: relative;
		top: 16px;
		background-image: url(../img/myVideo/volume.svg);
	}
  .my-video #volume_box{
		/* background: red; */
		position: relative;
	}

  .my-video #volumeInput {
		width: 32px;
		height: 120px;
		position: absolute;
		/* left: 940px;
        top: -105px; */
		left: 0;
		top: -100px;
		display: none;
		/* background: red; */
	}

  .my-video #volumeInputRange {
		transform: rotate(270deg);
		-webkit-appearance: none;
		width: 120px;
		height: 5px;
		/* border: 1px solid red; */
		position: absolute;
		left: -50px;
		top: 40px;
		background-color: #eee;
		border-radius: 2.5px;
	}

  .my-video #volumeInputRange::-webkit-slider-thumb {
		-webkit-appearance: none;
		width: 12px;
		height: 12px;
		cursor: pointer;
		background: none repeat scroll 0 0 #ffffff;
		border-radius: 6px;
	}

  .my-video #volume:hover+#volumeInput {
		display: block;
	}

  .my-video #volumeInput:hover {
		display: block;
	}

  .my-video #fullScreen {
		width: 54px;
		height: 36px;
		/* border: 1px solid red; */
		position: relative;
		top: 16px;
		background-image: url(../img/myVideo/fullscreen.svg);
		background-repeat: no-repeat;
	}
</style>